const workExperience = [
	{
		jobTitle: "Software Developer Intern",
		company: "Intuit - TurboTax",
		date: "May 2024 - August 2024",
		location: "Toronto, ON, Canada",
		description: [
			"Created the Canadian Product and Pricing page using React and Typescript",
			"Singlehandedly investigated the integration of design libraries, rendering systems, and pricing services",
			"Designed a tech system along with a senior engineer that followed dependency inversion",
			"Planned the project execution by breaking it into tickets that could be worked in in parallel, prioritized tasks based on a tight deadline",
		],
		logo: "intuit-turbotax.jpg",
		link: "https://turbotax.intuit.ca/tax/pricing",
		linkTitle: "TurboTax Canada Product and Pricing Page",
	},
	{
		jobTitle: "Embedded Software Network Developer Intern",
		company: "Ciena",
		date: "August 2023 - April 2024",
		location: "Ottawa, ON, Canada",
		description: [
			"Modified existing testing infrastructure in Python to allow testing on network topologies containing both 6500 and WaveRouter devices",
			"Automated logical port, IP interface, and MPLS configuration using Python",
		],
		logo: "ciena.png",
	},
	{
		jobTitle: "Software Developer Intern",
		company: "SAP Concur",
		date: "Spetember 2022 - April 2023",
		location: "Vancouver, BC, Canada",
		description: [
			"Created and modified APIs in a Spring Boot Java application using AWS DynamoDB to store data",
			"Wrote Redux actions and reducers, and created React components in JavaScript to implement a new feature to search and filter expense types",
			"Wrote tests using JUnit, Mockito, Jest, and Enzyme to ensure high code coverage",
		],
		logo: "sap-concur.png",
	},
	{
		jobTitle: "Teaching Assistant / Corrector",
		company: "University of Ottawa",
		date: "September 2021 - December 2021, September 2022 - December 2022",
		location: "Ottawa, ON, Canada",
		description: [
			"Presented lab material and solutions along with another TA to 60+ students for a Python course",
			"Hosted weekly office hours to answer student questions about course material",
			"Corrected 260+ assignments and tests, resolved grade inquiries",
		],
		logo: "uottawa.png",
	},
	{
		jobTitle: "Software Engineering Intern",
		company: "AEPONYX Inc.",
		date: "May 2022 - August 2022",
		location: "Montreal, QC, Canada",
		description: [
			"Created applications in C# using .NET and Python to automate lab tests and data analysis",
			"Communicated with multiple hardware devices using C# and Python",
			"Created user interfaces in WPF using XAML for handling measurement parameters, device connection, and presentation of results",
		],
		logo: "aeponyx.png",
	},
	{
		jobTitle: "Web Developer Intern",
		company: "Treasury Board of Canada Secretariat",
		date: "May 2021 - April 2022",
		location: "Ottawa, ON, Canada",
		description: [
			"Worked on a federal data visualization website with close to 223,000 page views per year",
			"Used JavaScript and Typescript to write and rewrite custom React components for improved usability and code maintainability",
			"Manipulated data using lodash to allow grouping data by specified attributes",
			"Selected out of 3 students to continue working part-time after the co-op term finished",
		],
		logo: "tbs.png",
		link: "https://www.tbs-sct.canada.ca/ems-sgd/edb-bdd/index-eng.html#start",
		linkTitle: "GC Infobase Website",
	},
];

export default workExperience;
